import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

import { Tooltip } from 'common/components';
import { getLandCategoryOptions } from 'common/utils/helpers/systemsValues';

import ReactHookFormCategorySelect from './ReactHookFormCategorySelect';

const LandCategoryWithTooltip = ({ control, systemUid }) => {
    const { t } = useTranslation();
    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
            <ReactHookFormCategorySelect
                control={control}
                label={t('Land category')}
                name="category"
                options={getLandCategoryOptions(systemUid)}
            />

            <Box>
                <Tooltip sx={{ maxWidth: '400px' }}>
                    <Trans>
                        To find out the land category in your area, consult the
                        following{' '}
                        <a
                            href="https://academy.alurack.sunwise.io/es/articles/12328880-categorias-de-terreno"
                            target="_blank"
                            rel="noreferrer"
                        >
                            link
                        </a>
                    </Trans>
                </Tooltip>
            </Box>
        </Box>
    );
};

LandCategoryWithTooltip.propTypes = {
    control: PropTypes.object,
    systemUid: PropTypes.string,
};

export default LandCategoryWithTooltip;
